import * as ambassadorWixPaymentsPayoutsV4Payout from './payments-payouts-v4-payout-payouts.http.js';
import * as ambassadorWixPaymentsPayoutsV4PayoutTypes from './payments-payouts-v4-payout-payouts.types.js';
import * as ambassadorWixPaymentsPayoutsV4PayoutUniversalTypes from './payments-payouts-v4-payout-payouts.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function listPayouts(): __PublicMethodMetaInfo<
  'GET',
  {},
  ambassadorWixPaymentsPayoutsV4PayoutUniversalTypes.ListPayoutsRequest,
  ambassadorWixPaymentsPayoutsV4PayoutTypes.ListPayoutsRequest,
  ambassadorWixPaymentsPayoutsV4PayoutUniversalTypes.ListPayoutsResponse,
  ambassadorWixPaymentsPayoutsV4PayoutTypes.ListPayoutsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixPaymentsPayoutsV4Payout.listPayouts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v4/payouts',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getPayout(): __PublicMethodMetaInfo<
  'GET',
  { payoutId: string },
  ambassadorWixPaymentsPayoutsV4PayoutUniversalTypes.GetPayoutRequest,
  ambassadorWixPaymentsPayoutsV4PayoutTypes.GetPayoutRequest,
  ambassadorWixPaymentsPayoutsV4PayoutUniversalTypes.GetPayoutResponse,
  ambassadorWixPaymentsPayoutsV4PayoutTypes.GetPayoutResponse
> {
  const payload = { payoutId: ':payoutId' } as any;

  const getRequestOptions =
    ambassadorWixPaymentsPayoutsV4Payout.getPayout(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v4/payouts/{payoutId}',
    pathParams: { payoutId: 'payoutId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  Payout as PayoutOriginal,
  Money as MoneyOriginal,
  PayoutStatus as PayoutStatusOriginal,
  PayoutStatusWithLiterals as PayoutStatusWithLiteralsOriginal,
  PayoutFailureReason as PayoutFailureReasonOriginal,
  PayoutFailureCode as PayoutFailureCodeOriginal,
  PayoutFailureCodeWithLiterals as PayoutFailureCodeWithLiteralsOriginal,
  ListPayoutsRequest as ListPayoutsRequestOriginal,
  Sorting as SortingOriginal,
  SortOrder as SortOrderOriginal,
  SortOrderWithLiterals as SortOrderWithLiteralsOriginal,
  AddressLocation as AddressLocationOriginal,
  Paging as PagingOriginal,
  ListPayoutsResponse as ListPayoutsResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  CreatePayoutRequest as CreatePayoutRequestOriginal,
  CreatePayoutResponse as CreatePayoutResponseOriginal,
  GetPayoutRequest as GetPayoutRequestOriginal,
  GetPayoutResponse as GetPayoutResponseOriginal,
  ListPayoutGroupsRequest as ListPayoutGroupsRequestOriginal,
  ListPayoutGroupsResponse as ListPayoutGroupsResponseOriginal,
  PayoutGroup as PayoutGroupOriginal,
  GetPayoutGroupRequest as GetPayoutGroupRequestOriginal,
  GetPayoutGroupResponse as GetPayoutGroupResponseOriginal,
  GetPayoutGroupByPayoutIdRequest as GetPayoutGroupByPayoutIdRequestOriginal,
  GetPayoutGroupByPayoutIdResponse as GetPayoutGroupByPayoutIdResponseOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './payments-payouts-v4-payout-payouts.types.js';
